export const IS_VISIBLE_TO_DISTRICT_FORM_FIELD_NAME = "isVisibleToDistrict";